// §0.5.3 Flask System — SVG icons for lab result status
// Three states: gray (overdue order), red (unreviewed result), orange (reviewed + flagged)
// Sizes: 16×16 in patient panel, 20×20 in flow sheet grid cells

interface FlaskProps {
  size?: number
  className?: string
}

// Gray flask: labs ordered — no result after 7 days
export const GrayFlaskIcon = ({ size = 16, className }: FlaskProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Overdue lab — no result after 7 days"
    className={className}>
    <path
      d="M6 2h4M6 2v4L3 13a1 1 0 00.93 1.38h8.14A1 1 0 0013 13L10 6V2M6 2H5M10 2h1"
      stroke="#A0AEC0"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5 10h6" stroke="#A0AEC0" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
)

// Red flask: result returned — not yet reviewed by provider
export const RedFlaskIcon = ({ size = 16, className }: FlaskProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Lab result returned — not yet reviewed"
    className={className}>
    <path
      d="M6 2h4M6 2v4L3 13a1 1 0 00.93 1.38h8.14A1 1 0 0013 13L10 6V2M6 2H5M10 2h1"
      stroke="#E53E3E"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 10.5h7l0.5 1.5H4l0.5-1.5z" fill="#E53E3E" opacity="0.7" />
    <path d="M5 10.5h6" stroke="#E53E3E" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
)

// Orange flask: result reviewed — flagged value (historical record)
export const OrangeFlaskIcon = ({ size = 16, className }: FlaskProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Lab result reviewed — flagged value"
    className={className}>
    <path
      d="M6 2h4M6 2v4L3 13a1 1 0 00.93 1.38h8.14A1 1 0 0013 13L10 6V2M6 2H5M10 2h1"
      stroke="#DD6B20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 10.5h7l0.5 1.5H4l0.5-1.5z" fill="#DD6B20" opacity="0.5" />
    <path d="M5 10.5h6" stroke="#DD6B20" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
)
